<div data-cy="availability-list-item">
  <div
    class="availability-day-item"
    [class.active]="!(collapsed$ | async)"
    [class.no-shifts-selected]="!(availableShifts$ | async)?.length"
    [class.booked]="working$ | async">
    <div class="availability-day-item__header">
      <div class="availability-day-item__header-row">
        <div
          class="availability-day-item__icon-col-space"
          (click)="toggleCollapsed($event)">
          <app-availability-icon
            class="availability-day-item__icon"
            size="small"
            [availability]="
              (availabilityForToday$ | async) ?? undefined
            "></app-availability-icon>
        </div>
        <div
          *ngIf="date"
          class="availability-day-item__title"
          (click)="toggleCollapsed($event)">
          <b>{{ date | date: "EE" }}&nbsp;</b>
          {{ date | date }}
        </div>
        <div
          class="availability-day-item__day-availability-toggle"
          data-cy="set-day-availability-buttons"
          *ngIf="!(working$ | async)"
          (click)="$event.stopPropagation()">
          <app-toggle-buttons
            [disabled]="!(canUpdateAvailabilities$ | async)"
            [trueLabel]="('available' | i18n) || 'available' | titlecase"
            [falseLabel]="('unavailable' | i18n) || 'unavailable' | titlecase"
            [value]="(availabilityForToday$ | async)?.isAvailable"
            (valueChange)="
              toggleAvailabilityState($event)
            "></app-toggle-buttons>
        </div>
        <div
          *ngIf="working$ | async"
          class="availability-day-item__working-shift">
          <ng-container
            *ngFor="
              let workingShift of workingShifts$ | async;
              let last = last
            ">
            {{
              "shiftsLongName." + (shiftEnum | enumToArray)[workingShift]
                | i18n
                | titlecase
            }}
            <ng-container *ngIf="!last">,</ng-container>
          </ng-container>
          {{ "booked" | i18n }}
        </div>
        <div class="availability-day-item__square-button-space">
          <app-icon-button
            (click)="toggleCollapsed($event)"
            [flip]="!(collapsed$ | async)"
            data-cy="day-collapse-availabilities-button"></app-icon-button>
        </div>
      </div>
      <div
        *ngIf="(availableShifts$ | async)?.length || !(collapsed$ | async)"
        class="availability-day-item__header-row">
        <div class="availability-day-item__icon-col-space"></div>
        <div
          class="availability-day-item__selected-shifts-hint"
          (click)="toggleCollapsed($event)">
          <ng-container
            *ngFor="let shift of availableShifts$ | async; let last = last">
            {{ "shifts." + shift | i18n | titlecase }}
            <ng-container *ngIf="!last">,</ng-container>
          </ng-container>
          <mat-icon
            *ngIf="(availableShifts$ | async)?.length"
            class="extra-small-icon availability-day-item__shifts-info-icon"
            svgIcon="information-outline"
            [matTooltip]="
              ('selectedShiftsHint' | i18n) ||
              'Dies sind Ihre als verfügbar angegebenen Schichten. Den Standard können Sie in den Einstellungen anpassen.'
            "></mat-icon>
        </div>
        <div class="availability-day-item__square-button-space"></div>
      </div>
    </div>
    <div
      *ngIf="!(collapsed$ | async)"
      class="availability-day-item__content">
      <div class="availability-day-item__icon-col-space"></div>
      <div class="availability-day-item__shifts">
        <app-availability-shift-toggle-list
          class="availability-day-item__shift-toggle-list"
          [disabled]="!(canUpdateAvailabilities$ | async)"
          [availability]="(availabilityForToday$ | async) ?? undefined"
          (shiftToggled)="
            toggleShift($event)
          "></app-availability-shift-toggle-list>

        <div
          (click)="stopPropagation($event)"
          *ngIf="
            (permissionsService.canReadPoolerUsers$ | async) &&
              !(canUpdateAvailabilities$ | async);
            else canUpdate
          ">
          <div *ngIf="noteText$ | async">
            <textarea
              [disabled]="!(canUpdateAvailabilities$ | async)"
              matInput
              [placeholder]="
                ('description' | i18n) || 'description' | titlecase
              "
              [ngModel]="noteText$ | async"
              (ngModelChange)="noteText$.next($event)"
              name="description"
              rows="7"
              data-cy="description-input"
              class="note-textarea mb-2 p-2">
            </textarea>
            <button
              type="button"
              class="bordered-button"
              [disabled]="!(canUpdateAvailabilities$ | async)"
              mat-button>
              <ng-container *ngIf="noteText$ | async; else addNoteButtonText">
                {{ ("editNote" | i18n) || "Notiz bearbeitens" | uppercase }}
              </ng-container>
              <ng-template #addNoteButtonText>
                {{ ("addNote" | i18n) || "Notiz hinzufügens" | uppercase }}
              </ng-template>
            </button>
          </div>
          <button
            *ngIf="!(noteText$ | async)"
            (click)="editNote($event)"
            type="button"
            class="bordered-button"
            data-cy="note-button"
            [disabled]="!(canUpdateAvailabilities$ | async)"
            mat-button>
            <ng-container *ngIf="noteText$ | async; else addNoteButtonText">
              {{ ("editNote" | i18n) || "Notiz bearbeitens" | uppercase }}
            </ng-container>
            <ng-template #addNoteButtonText>
              {{ ("addNote" | i18n) || "Notiz hinzufügens" | uppercase }}
            </ng-template>
          </button>
        </div>
        <ng-template #canUpdate>
          <button
            *ngIf="!(isEditingNote$ | async); else noteEdit"
            (click)="editNote($event)"
            type="button"
            class="bordered-button"
            data-cy="note-button"
            mat-button>
            <ng-container *ngIf="noteText$ | async; else addNoteButtonText">
              {{ ("editNote" | i18n) || "Notiz bearbeitens" | uppercase }}
            </ng-container>
            <ng-template #addNoteButtonText>
              {{ ("addNote" | i18n) || "Notiz hinzufügens" | uppercase }}
            </ng-template>
          </button>
          <ng-template #noteEdit>
            <textarea
              matInput
              [placeholder]="
                ('description' | i18n) || 'description' | titlecase
              "
              [ngModel]="noteText$ | async"
              (ngModelChange)="noteText$.next($event)"
              (click)="stopPropagation($event)"
              name="description"
              rows="7"
              data-cy="description-input"
              class="note-textarea">
            </textarea>
            <button
              (click)="saveNote($event)"
              type="button"
              class="bordered-button save-note-button"
              data-cy="note-button"
              mat-button>
              {{ ("saveNote" | i18n) || "Notiz speichern" | uppercase }}
            </button>
          </ng-template>
        </ng-template>
      </div>
      <div class="availability-day-item__square-button-space"></div>
    </div>
  </div>
</div>
